import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '../../../elements/icon';

function StepIndicator({ step, onBack, showBack, onClose, showClose = true }) {
  const { t } = useTranslation();
  const dots = [1, 2, 3];

  const label =
    step === 1 ? t('CancelFlow_Step_Label1') : step === 2 ? t('CancelFlow_Step_Label2') : t('CancelFlow_Step_Label3');

  return (
    <div className="t-flex t-items-center t-gap-3 t-mb-6">
      <button
        type="button"
        className={`t-w-8 t-h-8 t-rounded-lg t-border t-flex t-items-center t-justify-center t-text-xs t-text-gray-500 t-transition
        ${
          showBack
            ? 't-border-gray-300 hover:t-border-secondary hover:t-bg-teal-bg hover:t-text-secondary'
            : 't-invisible t-pointer-events-none'
        }`}
        onClick={onBack}
        aria-label="Back"
      >
        <span className="">
          <Icon name="chevronLeft" size={16} color="#667085" className="!t-mt-[2px]" />
        </span>
      </button>

      <div className="t-flex t-items-center t-gap-2 t-flex-1">
        {dots.map((i) => {
          const base = 't-h-[6px] t-rounded-full t-transition-all';
          if (i < step) return <div key={i} className={`${base} t-w-[6px] t-bg-teal-mid t-opacity-60`} />;
          if (i === step) return <div key={i} className={`${base} t-w-5 t-bg-secondary`} />;
          return <div key={i} className={`${base} t-w-[6px] t-bg-teal-mid`} />;
        })}
        <span className="t-text-[11px] t-font-medium t-tracking-[0.08em] t-uppercase t-text-gray-500 t-ml-1">
          {label}
        </span>
      </div>

      <button
        type="button"
        className={`t-w-8 t-h-8 t-rounded-lg t-border t-flex t-items-center t-justify-center t-text-xs t-text-gray-500 t-transition
        ${
          showClose
            ? 't-border-gray-300 hover:t-border-secondary hover:t-bg-teal-bg hover:t-text-secondary'
            : 't-invisible t-pointer-events-none'
        }`}
        onClick={onClose}
        aria-label="Close"
      >
        <Icon name="cross" size={16} color="#667085" />
      </button>
    </div>
  );
}

export default StepIndicator;
